import shortid from "shortid";
import { value } from "../../../helpers";
import OperacaoFiscal from "./operacao-fiscal.entity";
import { formatPrecisaoFloat } from "../../../utils";

class NfSaidaItem {
  produtoId = null;
  unidade = null;
  quantidade = null;
  valor = null;
  subtotal = null;
  modeloTributacaoId = null;
  grupoTributacaoId = null;
  descricao = null;
  codigo = null;
  codigoBarra = null;
  gtin = null;
  ncm = null;
  cest = null;
  cfop = null;
  impostoIcmsStReducao = null;
  impostoIcmsStBase = null;
  impostoIcmsStAliquota = null;
  impostoIcmsSt = null;
  aliquotaMva = null;
  unidadeCom = null;
  unidadeTrib = null;
  quantidadeCom = null;
  quantidadeTrib = null;
  valorUnitarioComercial = null;
  valorUnitarioTributavel = null;
  desconto = null;
  acrescimo = null;
  frete = null;
  despesas = null;
  tributosIcmsOrigem = null;
  tributosIcmsCst = null;
  tributosIcmsCsosn = null;
  tributosIcmsBaseCalculoModalidade = null;
  tributosIcmsBaseCalculoModalidadeST = null;
  tributosIcmsBaseCalculoPercentualReducao = null;
  tributosIcmsBaseCalculoValor = null;
  tributosIcmsAliquota = null;
  tributosIcmsValor = null;
  tributosPisCst = null;
  tributosPisBaseCalculoValor = null;
  tributosPisBaseCalculoQuantidade = null;
  tributosPisAliquota = null;
  tributosPisValor = null;
  tributosCofinsCst = null;
  tributosCofinsBaseCalculoValor = null;
  tributosCofinsAliquota = null;
  tributosCofinsValor = null;
  tributosIpiCst = null;
  tributosIpiEnquadramento = null;
  tributosIpiAliquota = null;
  tributosIpiValor = null;
  tributosIpiBaseCalculoValor = null;
  informacaoAdicional = null;
  modeloTributacao = null;
  saldoExportar = null;
  operacaoFiscal = null;
  tipo = null;
  origemKitId = null;
  subtotal = null;
  quantidade = null;
  quantidadeKit = null;
  produtosKit = null;
  dataValidade = null;
  dataFabricacao = null;
  precoMaxConsumo = null;
  numLote = null;
  qtdLote = null;
  agregado = null;
  prodAnvisa = null;
  motivoIsencao = null;
  anpCodigo = null;
  anpDescricao = null;
  unidadeTributavelId = null;
  qtdTributavel = null;
  glp = null;
  gasNaturalNacional = null;
  gasNaturalImp = null;
  valorPartida = null;
  codif = null;
  qtdCombTempAmbiente = null;
  bcCide = null;
  aliquotaCide = null;
  valorCide = null;
  indicadorImportacao = null;
  ufOrigem = null;
  percentualUf = null;
  precoCusto = null;
  precoVenda = null;
  total = null;
  ordemCompra = null;
  numeroItem = null;
  tributosIbsCst = null;
  tributosIbsClassificacao = null;
  tributosIbsAliquotaUf = null;
  tributosIbsAliquotaMun = null;
  tributosIbsAliquotaCbs = null;
  nfSaidaItemOriginalId = null;
  tributosPisAliquota = null;
  tributosValorPisAliquota = null;
  tributosCofinsAliquota = null;
  tributosValorCofinsAliquota = null;
  tributosIbsBaseCalculo = null;
  enderecoEstoqueId = null;
  nfEntradaItemId = null;
  aliquotaDeferimentoUfIbs = null;
  aliquotaDeferimentoMunIbs = null;
  aliquotaDeferimentoCbs = null;
  chaveAcessoReferencia = null;
  numeroItemReferencia = null;

  constructor(item, index, operacaoFiscal, origensMercadoriaList, unidadeList) {
    this.id = item.id ? item.id : shortid.generate();
    this.ordem = index + 1;
    this.produtoId = item?.produtoId;
    this.quantidade = item.quantidade;
    this.saldoExportar = item.saldoExportar;
    this.grupoTributacaoId = item.grupoTributacaoId;
    this.modeloTributacaoId = item.modeloTributacaoId;
    this.codigo = item.codigo;
    this.gtin = item.gtin;
    this.codigoBarra = item.codigoBarra;
    this.descricao = item.descricao;
    this.desconto = item.desconto;
    this.frete = item.frete || item.valorFrete;
    this.despesas = item.despesas;
    this.acrescimo = item.acrescimo;
    this.unidade =
      !item.unidade && unidadeList?.length
        ? unidadeList.find(
            (unidade) =>
              unidade.codigo == item.unidade ||
              unidade.id == item.unidadeComercialVendaId,
          )?.codigo
        : item.unidade;
    this.ncm = item.ncmCodigo || item.ncm;
    this.cestId = item.cestId;
    this.informacaoAdicional =
      item.informacaoAdicional || item.informacaoAdicionalNfe;
    this.valor = item.valor || 0;
    this.subtotal = item.subtotal;
    this.cfop = item.cfop;
    if (
      operacaoFiscal?.finalidade !== "NOTA_CREDITO" &&
      operacaoFiscal?.finalidade !== "NOTA_DEBITO"
    ) {
      this.inicializarImpostos(item, origensMercadoriaList);
    }
    this.aliquotaMva = item.aliquotaMva;
    this.unidadeCom = item.unidadeCom;
    this.unidadeTrib = item.unidadeTributavelId
      ? unidadeList.find(
          (unidade) =>
            unidade.codigo == item.unidadeTributavelId ||
            unidade.id == item.unidadeTributavelId,
        )?.codigo
      : item.unidadeTrib;
    this.quantidadeCom = item.quantidadeCom;
    this.quantidadeTrib = item.quantidadeTrib;
    this.valorUnitarioComercial = item.valorUnitarioComercial;
    this.valorUnitarioTributavel = item.valorUnitarioTributavel;
    this.modeloTributacao = item.modeloTributacao;
    this.operacaoFiscal =
      !item.operacaoFiscal && operacaoFiscal
        ? new OperacaoFiscal(operacaoFiscal)
        : item.operacaoFiscal;
    this.tipo = item.tipo;
    this.origemKitId = item.origemKitId;
    this.quantidade = item.quantidade;
    this.quantidadeKit = item.quantidadeKit;
    this.produtosKit = item.produtosKit;
    this.dataValidade = item.dataValidade;
    this.dataFabricacao = item.dataFabricacao;
    this.precoMaxConsumo = item.precoMaxConsumo;
    this.numLote = item.numLote;
    this.qtdLote = item.qtdLote;
    this.agregado = item.agregado;
    this.prodAnvisa = item.prodAnvisa;
    this.motivoIsencao = item.motivoIsencao;
    this.anpCodigo = item.anpCodigo;
    this.anpDescricao = item.anpDescricao;
    this.qtdTributavel = item.qtdTributavel;
    this.glp = item.glp;
    this.gasNaturalNacional = item.gasNaturalNacional;
    this.gasNaturalImp = item.gasNaturalImp;
    this.valorPartida = item.valorPartida;
    this.codif = item.codif;
    this.qtdCombTempAmbiente = item.qtdCombTempAmbiente;
    this.bcCide = item.bcCide;
    this.aliquotaCide = item.aliquotaCide;
    this.valorCide = item.valorCide;
    this.indicadorImportacao = item.indicadorImportacao;
    this.ufOrigem = item.ufOrigem;
    this.percentualUf = item.percentualUf;
    this.precoCusto = item.precoCusto;
    this.precoVenda = item.informacao?.precoVenda
      ? item.informacao.precoVenda
      : item.precoVenda;
    this.ordemCompra = item.ordemCompra;
    this.numeroItem = item.numeroItem;
    this.tributosIbsBaseCalculo =
      item.tributosIbsBaseCalculo ||
      (item.tributosIbsBcParcial ?? 0) * item.quantidade;
    this.tributosIbsCst = item.tributosIbsCst;
    this.tributosIbsClassificacao = item.tributosIbsClassificacao;
    this.tributosIbsAliquotaUf = item.tributosIbsAliquotaUf;
    this.tributosIbsAliquotaMun = item.tributosIbsAliquotaMun;
    this.tributosIbsAliquotaCbs = item.tributosIbsAliquotaCbs;
    this.tributosIbsAliquotaRedUf = item.tributosIbsAliquotaRedUf;
    this.tributosIbsAliquotaRedMun = item.tributosIbsAliquotaRedMun;
    this.tributosIbsAliquotaRedCbs = item.tributosIbsAliquotaRedCbs;
    this.tributosIbsUfValor = item.tributosIbsBcParcial
      ? ((item.tributosIbsBcParcial ?? 0) *
          item.quantidade *
          (item.tributosIbsAliquotaUf ?? 0)) /
        100
      : item.tributosIbsUfValor;
    this.tributosIbsMunValor = item.tributosIbsBcParcial
      ? ((item.tributosIbsBcParcial ?? 0) *
          item.quantidade *
          (item.tributosIbsAliquotaMun ?? 0)) /
        100
      : item.tributosIbsMunValor;
    this.tributosCbsValor = item.tributosIbsBcParcial
      ? ((item.tributosIbsBcParcial ?? 0) *
          item.quantidade *
          (item.tributosIbsAliquotaCbs ?? 0)) /
        100
      : item.tributosCbsValor;
    this.nfSaidaItemOriginalId = item.nfSaidaItemOriginalId;
    this.enderecoEstoqueId = item.enderecoEstoqueId;
    this.nfEntradaItemId = item.nfEntradaItemId;
    this.aliquotaDeferimentoUfIbs = item.aliquotaDeferimentoUfIbs;
    this.aliquotaDeferimentoMunIbs = item.aliquotaDeferimentoMunIbs;
    this.aliquotaDeferimentoCbs = item.aliquotaDeferimentoCbs;
    this.chaveAcessoReferencia = item.chaveAcessoReferencia;
    this.numeroItemReferencia = item.numeroItemReferencia;
  }

  inicializarImpostos(item, origensMercadoriaList) {
    this.tributosIcmsOrigem =
      (item.tributosIcmsOrigem === undefined ||
        item.tributosIcmsOrigem === null) &&
      origensMercadoriaList?.length
        ? value.autoComplete(origensMercadoriaList, item?.origemMercadoriaId)
            .codigo
        : item.tributosIcmsOrigem;
    this.impostoIcmsStReducao = item.impostoIcmsStReducao;
    this.impostoIcmsStBase =
      item.impostoIcmsStBase ||
      (item.impostoIcmsStBcParcial ?? 0) * item.quantidade;
    this.impostoIcmsStAliquota = item.impostoIcmsStAliquota;
    this.impostoIcmsSt =
      item.impostoIcmsSt ||
      (item.impostoIcmsStBcParcial ?? 0) *
        item.quantidade *
        ((item.impostoIcmsStAliquota ?? 0) / 100);
    this.tributosIcmsCst = item.tributosIcmsCst || item.tributosIcmsCodigo;
    this.tributosIcmsCsosn = item.tributosIcmsCsosn;
    this.tributosIcmsBaseCalculoModalidade =
      item.tributosIcmsBaseCalculoModalidade || item.tributosIcmsModalidade;
    this.tributosIcmsBaseCalculoModalidadeST =
      item.tributosIcmsBaseCalculoModalidadeST;
    this.tributosIcmsBaseCalculoPercentualReducao =
      item.tributosIcmsBaseCalculoPercentualReducao;
    this.tributosIcmsBaseCalculoValor =
      item.tributosIcmsBaseCalculoValor ||
      (item.tributosIcmsBcParcial ?? 0) * item.quantidade;
    this.tributosIcmsAliquota = item.tributosIcmsAliquota;
    this.tributosIcmsValor =
      item.tributosIcmsValor ||
      ((item.tributosIcmsBcParcial ?? 0) *
        item.quantidade *
        (item.tributosIcmsAliquota ?? 0)) /
        100;
    this.tributosPisCst = item.tributosPisCst || item.tributosPisCodigo;
    this.tributosPisBaseCalculoValor =
      item.tributosPisBaseCalculoValor ||
      (item.tributosPisBcParcial ?? 0) * item.quantidade;
    this.tributosPisBaseCalculoQuantidade =
      item.tributosPisBaseCalculoQuantidade;
    this.tributosPisAliquota = item.tributosPisAliquota;
    this.tributosPisValor =
      item.tributosPisValor ||
      ((item.tributosPisBcParcial ?? 0) *
        item.quantidade *
        (item.tributosPisAliquota ?? 0)) /
        100;
    this.tributosCofinsCst =
      item.tributosCofinsCst || item.tributosCofinsCodigo;
    this.tributosCofinsBaseCalculoValor =
      item.tributosCofinsBaseCalculoValor ||
      (item.tributosCofinsBcParcial ?? 0) * item.quantidade;
    this.tributosCofinsAliquota = item.tributosCofinsAliquota;
    this.tributosCofinsValor =
      item.tributosCofinsValor ||
      ((item.tributosCofinsBcParcial ?? 0) *
        item.quantidade *
        (item.tributosCofinsAliquota ?? 0)) /
        100;
    this.tributosIpiCst = item.tributosIpiCst || item.tributosIpiCodigo;
    this.tributosIpiEnquadramento = item.tributosIpiEnquadramento;
    this.tributosIpiAliquota = item.tributosIpiAliquota;
    this.tributosIpiValor =
      item.tributosIpiValor ||
      ((item.tributosIpiBcParcial ?? 0) *
        item.quantidade *
        (item.tributosIpiAliquota ?? 0)) /
        100;
    this.tributosIpiBaseCalculoValor =
      item.tributosIpiBaseCalculoValor ||
      (item.tributosIpiBcParcial ?? 0) * item.quantidade;
  }

  setAliquotasIcmsIbs(modeloTributacao) {
    this.calculaIcmsSt = modeloTributacao.calculaIcmsSt;
    this.tributosIcmsCsosn = modeloTributacao.csoSimplesNacional;
    this.impostoIcmsStAliquota = modeloTributacao.aliquotaSt;
    this.aliquotaMva = modeloTributacao.aliquotaMva;
    this.freteNaBaseSt = modeloTributacao.freteNaBaseSt;
    this.despesaNaBaseSt = modeloTributacao.despesaNaBaseSt;
    this.descontoNaBaseSt = modeloTributacao.descontoNaBaseSt;
    this.tributosIbsAliquotaUf = modeloTributacao.aliquotaIbsUf;
    this.tributosIbsAliquotaMun = modeloTributacao.aliquotaIbsMun;
    this.tributosIbsAliquotaCbs = modeloTributacao.aliquotaCbs;
    this.tributosIbsAliquotaRedUf = modeloTributacao.aliquotaIbsUfRed;
    this.tributosIbsAliquotaRedMun = modeloTributacao.aliquotaIbsMunRed;
    this.tributosIbsAliquotaRedCbs = modeloTributacao.aliquotaCbsRed;
    this.aliquotaDeferimentoUfIbs = modeloTributacao.aliquotaDeferimentoUfIbs;
    this.aliquotaDeferimentoMunIbs = modeloTributacao.aliquotaDeferimentoMunIbs;
    this.aliquotaDeferimentoCbs = modeloTributacao.aliquotaDeferimentoCbs;
  }

  setTotal(item, nfSaida) {
    const frete =
      nfSaida?.freteCompoeNota && item.frete ? parseFloat(item.frete) : 0;
    this.total =
      parseFloat(item.subtotal) -
      parseFloat(item.desconto || 0) +
      frete +
      parseFloat(item.despesas || 0);
  }

  setDescricao(descricao) {
    this.descricao = descricao;
  }

  setValor(valor) {
    this.valor = parseFloat(valor);
  }

  setSubtotal() {
    if (!this.subtotal) {
      this.subtotal = formatPrecisaoFloat(
        parseFloat(this.valor ?? 0) * parseFloat(this.quantidade ?? 1),
      );
    }
  }

  setImposto(item) {
    this.tributosIcmsAliquota = item.tributosIcmsAliquota;
    this.tributosIpiAliquota = item.tributosIpiAliquota;
    this.aliquotaMva = item.aliquotaMva;
    this.impostoIcmsStAliquota = item.impostoIcmsStAliquota;
    //this.tributosIcmsValor = nfSaidaTotalTributos.calculaValorIcms(item, {});
  }

  setTributosIcmsCsosn(value) {
    this.tributosIcmsCsosn = value;
  }

  setReferencia(chaveAcesso, numeroItem) {
    this.chaveAcessoReferencia = chaveAcesso;
    this.numeroItemReferencia = numeroItem;
  }

  setInputAttribute(name, value) {
    this[name] = value;
  }
}

export default NfSaidaItem;
